//////////////////////////////////////////////////////////////////////////////////////////////
// DO NOT MODIFY THIS FILE                                                                  //
// This file is automatically generated by ZenStack CLI and should not be manually updated. //
//////////////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */

import { type SchemaDef, type AttributeApplication, type FieldDefault, ExpressionUtils } from "@zenstackhq/schema";
export class SchemaType implements SchemaDef {
    provider = {
        type: "postgresql"
    } as const;
    models = {
        User: {
            name: "User",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                email: {
                    name: "email",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }, { name: "@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("id"))), "||", ExpressionUtils.binary(ExpressionUtils.field("memberships"), "?", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "!=", ExpressionUtils.literal("VIEWER")))))) }] }] as readonly AttributeApplication[]
                },
                password: {
                    name: "password",
                    type: "String",
                    omit: true,
                    attributes: [{ name: "@omit" }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }, { name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                notificationsEnabled: {
                    name: "notificationsEnabled",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                dndStart: {
                    name: "dndStart",
                    type: "String",
                    optional: true
                },
                dndEnd: {
                    name: "dndEnd",
                    type: "String",
                    optional: true
                },
                dndTimezone: {
                    name: "dndTimezone",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("Europe/Sofia") }] }] as readonly AttributeApplication[],
                    default: "Europe/Sofia" as FieldDefault
                },
                memberships: {
                    name: "memberships",
                    type: "AccountMember",
                    array: true,
                    relation: { opposite: "user" }
                },
                invitesSent: {
                    name: "invitesSent",
                    type: "Invite",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("invitedBy") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "invitedBy", name: "invitedBy" }
                },
                authoredMessages: {
                    name: "authoredMessages",
                    type: "Message",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("messageAuthor") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "createdBy", name: "messageAuthor" }
                },
                messageReads: {
                    name: "messageReads",
                    type: "MessageRead",
                    array: true,
                    relation: { opposite: "user" }
                },
                callReads: {
                    name: "callReads",
                    type: "CallRead",
                    array: true,
                    relation: { opposite: "user" }
                },
                auditEntries: {
                    name: "auditEntries",
                    type: "AuditLog",
                    array: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("auditActor") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "actor", name: "auditActor" }
                },
                pushSubscriptions: {
                    name: "pushSubscriptions",
                    type: "PushSubscription",
                    array: true,
                    relation: { opposite: "user" }
                },
                sessionsValidFrom: {
                    name: "sessionsValidFrom",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("id")))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.field("memberships"), "?", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("id")))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("id")))) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                email: { type: "String" }
            }
        },
        Account: {
            name: "Account",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                retentionDays: {
                    name: "retentionDays",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(30) }] }] as readonly AttributeApplication[],
                    default: 30 as FieldDefault
                },
                members: {
                    name: "members",
                    type: "AccountMember",
                    array: true,
                    relation: { opposite: "account" }
                },
                assistantConfig: {
                    name: "assistantConfig",
                    type: "AssistantConfig",
                    optional: true,
                    relation: { opposite: "account" }
                },
                voiceAgent: {
                    name: "voiceAgent",
                    type: "VoiceAgent",
                    optional: true,
                    relation: { opposite: "account" }
                },
                onboardingProgress: {
                    name: "onboardingProgress",
                    type: "OnboardingProgress",
                    optional: true,
                    relation: { opposite: "account" }
                },
                phoneNumbers: {
                    name: "phoneNumbers",
                    type: "PhoneNumber",
                    array: true,
                    relation: { opposite: "account" }
                },
                faqEntries: {
                    name: "faqEntries",
                    type: "FaqEntry",
                    array: true,
                    relation: { opposite: "account" }
                },
                contacts: {
                    name: "contacts",
                    type: "Contact",
                    array: true,
                    relation: { opposite: "account" }
                },
                blockedCallers: {
                    name: "blockedCallers",
                    type: "BlockedCaller",
                    array: true,
                    relation: { opposite: "account" }
                },
                tags: {
                    name: "tags",
                    type: "Tag",
                    array: true,
                    relation: { opposite: "account" }
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "account" }
                },
                messages: {
                    name: "messages",
                    type: "Message",
                    array: true,
                    relation: { opposite: "account" }
                },
                auditLog: {
                    name: "auditLog",
                    type: "AuditLog",
                    array: true,
                    relation: { opposite: "account" }
                },
                invites: {
                    name: "invites",
                    type: "Invite",
                    array: true,
                    relation: { opposite: "account" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                },
                hasActiveNumber: {
                    name: "hasActiveNumber",
                    type: "Boolean",
                    attributes: [{ name: "@computed" }] as readonly AttributeApplication[],
                    computed: true
                },
                agentConfigured: {
                    name: "agentConfigured",
                    type: "Boolean",
                    attributes: [{ name: "@computed" }] as readonly AttributeApplication[],
                    computed: true
                },
                onboardingComplete: {
                    name: "onboardingComplete",
                    type: "Boolean",
                    attributes: [{ name: "@computed" }] as readonly AttributeApplication[],
                    computed: true
                },
                isActiveCustomer: {
                    name: "isActiveCustomer",
                    type: "Boolean",
                    attributes: [{ name: "@computed" }] as readonly AttributeApplication[],
                    computed: true
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.field("members"), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.field("members"), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            },
            computedFields: {
                hasActiveNumber(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                },
                agentConfigured(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                },
                onboardingComplete(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                },
                isActiveCustomer(_context: {
                    modelAlias: string;
                }): boolean {
                    throw new Error("This is a stub for computed field");
                }
            }
        },
        AccountMember: {
            name: "AccountMember",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    attributes: [{ name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "members", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    attributes: [{ name: "@deny", args: [{ name: "operation", value: ExpressionUtils.literal("update") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "!=", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "memberships", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                role: {
                    name: "role",
                    type: "AccountRole",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("VIEWER") }] }] as readonly AttributeApplication[],
                    default: "VIEWER" as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("userId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_userId: { accountId: { type: "String" }, userId: { type: "String" } }
            }
        },
        PhoneNumber: {
            name: "PhoneNumber",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "phoneNumbers", fields: ["accountId"], references: ["id"], onDelete: "SetNull" }
                },
                e164: {
                    name: "e164",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                provider: {
                    name: "provider",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("zadarma") }] }] as readonly AttributeApplication[],
                    default: "zadarma" as FieldDefault
                },
                providerNumberId: {
                    name: "providerNumberId",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "ProvisioningStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("PROVISIONING") }] }] as readonly AttributeApplication[],
                    default: "PROVISIONING" as FieldDefault
                },
                purchasedAt: {
                    name: "purchasedAt",
                    type: "DateTime",
                    optional: true
                },
                releasedAt: {
                    name: "releasedAt",
                    type: "DateTime",
                    optional: true
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "phoneNumber" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("status")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                e164: { type: "String" }
            }
        },
        CarrierForwardingCode: {
            name: "CarrierForwardingCode",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                country: {
                    name: "country",
                    type: "String"
                },
                carrier: {
                    name: "carrier",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String"
                },
                enableCode: {
                    name: "enableCode",
                    type: "String"
                },
                disableCode: {
                    name: "disableCode",
                    type: "String"
                },
                statusCode: {
                    name: "statusCode",
                    type: "String",
                    optional: true
                },
                notes: {
                    name: "notes",
                    type: "Json",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("country"), ExpressionUtils.field("carrier")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.call("auth"), "!=", ExpressionUtils._null()) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                country_carrier: { country: { type: "String" }, carrier: { type: "String" } }
            }
        },
        Voice: {
            name: "Voice",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String"
                },
                voiceId: {
                    name: "voiceId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                language: {
                    name: "language",
                    type: "String",
                    optional: true
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                configs: {
                    name: "configs",
                    type: "AssistantConfig",
                    array: true,
                    relation: { opposite: "voice" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                voiceId: { type: "String" }
            }
        },
        AssistantConfig: {
            name: "AssistantConfig",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "assistantConfig", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                greetingName: {
                    name: "greetingName",
                    type: "String",
                    optional: true
                },
                greetingScript: {
                    name: "greetingScript",
                    type: "String",
                    optional: true
                },
                voiceId: {
                    name: "voiceId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "voice"
                    ] as readonly string[]
                },
                voice: {
                    name: "voice",
                    type: "Voice",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("voiceId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "configs", fields: ["voiceId"], references: ["id"], onDelete: "SetNull" }
                },
                customInstructions: {
                    name: "customInstructions",
                    type: "String",
                    optional: true
                },
                emergencyTopics: {
                    name: "emergencyTopics",
                    type: "String",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                language: {
                    name: "language",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("bg") }] }] as readonly AttributeApplication[],
                    default: "bg" as FieldDefault
                },
                autoSwitchEnglish: {
                    name: "autoSwitchEnglish",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                ownNumber: {
                    name: "ownNumber",
                    type: "String",
                    optional: true
                },
                carrier: {
                    name: "carrier",
                    type: "String",
                    optional: true
                },
                forwardingConfirmedAt: {
                    name: "forwardingConfirmedAt",
                    type: "DateTime",
                    optional: true
                },
                minUrgencyToNotify: {
                    name: "minUrgencyToNotify",
                    type: "UrgencyLevel",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("NORMAL") }] }] as readonly AttributeApplication[],
                    default: "NORMAL" as FieldDefault
                },
                smsFallbackFrom: {
                    name: "smsFallbackFrom",
                    type: "UrgencyLevel",
                    optional: true
                },
                shortCircuitSpam: {
                    name: "shortCircuitSpam",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId: { type: "String" }
            }
        },
        VoiceAgent: {
            name: "VoiceAgent",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "voiceAgent", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                config: {
                    name: "config",
                    type: "Json",
                    optional: true
                },
                faqDocumentId: {
                    name: "faqDocumentId",
                    type: "String",
                    optional: true
                },
                knowledgeDocs: {
                    name: "knowledgeDocs",
                    type: "AgentKnowledgeDoc",
                    array: true,
                    relation: { opposite: "agent" }
                },
                syncedAt: {
                    name: "syncedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId: { type: "String" },
                externalAgentId: { type: "String" }
            }
        },
        CreditPackage: {
            name: "CreditPackage",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                price: {
                    name: "price",
                    type: "Int"
                },
                currency: {
                    name: "currency",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("EUR") }] }] as readonly AttributeApplication[],
                    default: "EUR" as FieldDefault
                },
                credits: {
                    name: "credits",
                    type: "Int"
                },
                active: {
                    name: "active",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(true) }] }] as readonly AttributeApplication[],
                    default: true as FieldDefault
                },
                sortOrder: {
                    name: "sortOrder",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        AgentKnowledgeDoc: {
            name: "AgentKnowledgeDoc",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                agentId: {
                    name: "agentId",
                    type: "String",
                    foreignKeyFor: [
                        "agent"
                    ] as readonly string[]
                },
                agent: {
                    name: "agent",
                    type: "VoiceAgent",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("agentId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "knowledgeDocs", fields: ["agentId"], references: ["id"], onDelete: "Cascade" }
                },
                title: {
                    name: "title",
                    type: "String"
                },
                text: {
                    name: "text",
                    type: "String"
                },
                documentId: {
                    name: "documentId",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("agentId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("agent"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("agent"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        FaqEntry: {
            name: "FaqEntry",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "faqEntries", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                question: {
                    name: "question",
                    type: "String"
                },
                answer: {
                    name: "answer",
                    type: "String"
                },
                position: {
                    name: "position",
                    type: "Int",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(0) }] }] as readonly AttributeApplication[],
                    default: 0 as FieldDefault
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("position")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        OnboardingProgress: {
            name: "OnboardingProgress",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "onboardingProgress", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                currentStep: {
                    name: "currentStep",
                    type: "OnboardingStep",
                    optional: true
                },
                skippedSteps: {
                    name: "skippedSteps",
                    type: "OnboardingStep",
                    array: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.array("Any", []) }] }] as readonly AttributeApplication[],
                    default: [] as FieldDefault
                },
                completedAt: {
                    name: "completedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId: { type: "String" }
            }
        },
        Call: {
            name: "Call",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                conversationId: {
                    name: "conversationId",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "calls", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                phoneNumberId: {
                    name: "phoneNumberId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "phoneNumber"
                    ] as readonly string[]
                },
                phoneNumber: {
                    name: "phoneNumber",
                    type: "PhoneNumber",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("phoneNumberId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "calls", fields: ["phoneNumberId"], references: ["id"], onDelete: "SetNull" }
                },
                callerName: {
                    name: "callerName",
                    type: "String",
                    optional: true
                },
                callerNumber: {
                    name: "callerNumber",
                    type: "String",
                    optional: true
                },
                contactId: {
                    name: "contactId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "contact"
                    ] as readonly string[]
                },
                contact: {
                    name: "contact",
                    type: "Contact",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "calls", fields: ["contactId"], references: ["id"], onDelete: "SetNull" }
                },
                status: {
                    name: "status",
                    type: "CallStatus",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("COMPLETED") }] }] as readonly AttributeApplication[],
                    default: "COMPLETED" as FieldDefault
                },
                urgencyLevel: {
                    name: "urgencyLevel",
                    type: "UrgencyLevel",
                    optional: true
                },
                startedAt: {
                    name: "startedAt",
                    type: "DateTime",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "DateTime",
                    optional: true
                },
                durationSec: {
                    name: "durationSec",
                    type: "Int",
                    optional: true
                },
                endedReason: {
                    name: "endedReason",
                    type: "String",
                    optional: true
                },
                providerCostCents: {
                    name: "providerCostCents",
                    type: "Int",
                    optional: true
                },
                telephonyCostCents: {
                    name: "telephonyCostCents",
                    type: "Int",
                    optional: true
                },
                messages: {
                    name: "messages",
                    type: "Json",
                    optional: true
                },
                recording: {
                    name: "recording",
                    type: "CallRecording",
                    optional: true,
                    relation: { opposite: "call" }
                },
                transcript: {
                    name: "transcript",
                    type: "Transcript",
                    optional: true,
                    relation: { opposite: "call" }
                },
                summary: {
                    name: "summary",
                    type: "CallSummary",
                    optional: true,
                    relation: { opposite: "call" }
                },
                tags: {
                    name: "tags",
                    type: "CallTag",
                    array: true,
                    relation: { opposite: "call" }
                },
                reads: {
                    name: "reads",
                    type: "CallRead",
                    array: true,
                    relation: { opposite: "call" }
                },
                notification: {
                    name: "notification",
                    type: "Message",
                    optional: true,
                    relation: { opposite: "call" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("startedAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("urgencyLevel")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callerNumber")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("phoneNumberId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("contactId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                conversationId: { type: "String" }
            }
        },
        CallRecording: {
            name: "CallRecording",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "recording", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                storageKey: {
                    name: "storageKey",
                    type: "String"
                },
                mimeType: {
                    name: "mimeType",
                    type: "String",
                    optional: true,
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("audio/mpeg") }] }] as readonly AttributeApplication[],
                    default: "audio/mpeg" as FieldDefault
                },
                sizeBytes: {
                    name: "sizeBytes",
                    type: "Int",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                deletedAt: {
                    name: "deletedAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("DateTime", [ExpressionUtils.field("expiresAt"), ExpressionUtils.field("deletedAt")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        Transcript: {
            name: "Transcript",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "transcript", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                content: {
                    name: "content",
                    type: "String"
                },
                language: {
                    name: "language",
                    type: "String",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("DateTime", [ExpressionUtils.field("expiresAt")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        CallSummary: {
            name: "CallSummary",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "summary", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                summaryText: {
                    name: "summaryText",
                    type: "String"
                },
                model: {
                    name: "model",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        CallRead: {
            name: "CallRead",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "reads", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "callReads", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId"), ExpressionUtils.field("userId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId"))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId")), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId_userId: { callId: { type: "String" }, userId: { type: "String" } }
            }
        },
        Tag: {
            name: "Tag",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "tags", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                slug: {
                    name: "slug",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "Json"
                },
                isSystemDefault: {
                    name: "isSystemDefault",
                    type: "Boolean",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal(false) }] }] as readonly AttributeApplication[],
                    default: false as FieldDefault
                },
                calls: {
                    name: "calls",
                    type: "CallTag",
                    array: true,
                    relation: { opposite: "tag" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("slug")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("accountId"), "==", ExpressionUtils._null()), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,update,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("accountId"), "!=", ExpressionUtils._null()), "&&", ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"])), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_slug: { accountId: { type: "String" }, slug: { type: "String" } }
            }
        },
        CallTag: {
            name: "CallTag",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                callId: {
                    name: "callId",
                    type: "String",
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "tags", fields: ["callId"], references: ["id"], onDelete: "Cascade" }
                },
                tagId: {
                    name: "tagId",
                    type: "String",
                    foreignKeyFor: [
                        "tag"
                    ] as readonly string[]
                },
                tag: {
                    name: "tag",
                    type: "Tag",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("tagId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "calls", fields: ["tagId"], references: ["id"], onDelete: "Cascade" }
                },
                source: {
                    name: "source",
                    type: "TagSource",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("AUTO") }] }] as readonly AttributeApplication[],
                    default: "AUTO" as FieldDefault
                },
                confidence: {
                    name: "confidence",
                    type: "Float",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId"), ExpressionUtils.field("tagId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("tagId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,update,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("call"), ["account", "members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "!=", ExpressionUtils.literal("VIEWER"))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId_tagId: { callId: { type: "String" }, tagId: { type: "String" } }
            }
        },
        Contact: {
            name: "Contact",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "contacts", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                e164: {
                    name: "e164",
                    type: "String",
                    attributes: [{ name: "@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "!=", ExpressionUtils.literal("VIEWER"))))) }] }] as readonly AttributeApplication[]
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                relationshipTag: {
                    name: "relationshipTag",
                    type: "String",
                    optional: true
                },
                notes: {
                    name: "notes",
                    type: "String",
                    optional: true
                },
                callMessage: {
                    name: "callMessage",
                    type: "String",
                    optional: true
                },
                callMessageExpiresAt: {
                    name: "callMessageExpiresAt",
                    type: "DateTime",
                    optional: true
                },
                calls: {
                    name: "calls",
                    type: "Call",
                    array: true,
                    relation: { opposite: "contact" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("e164")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,update,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "!=", ExpressionUtils.literal("VIEWER"))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_e164: { accountId: { type: "String" }, e164: { type: "String" } }
            }
        },
        BlockedCaller: {
            name: "BlockedCaller",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "blockedCallers", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                e164: {
                    name: "e164",
                    type: "String"
                },
                source: {
                    name: "source",
                    type: "TagSource",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("AUTO") }] }] as readonly AttributeApplication[],
                    default: "AUTO" as FieldDefault
                },
                reason: {
                    name: "reason",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("e164")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,update,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                accountId_e164: { accountId: { type: "String" }, e164: { type: "String" } }
            }
        },
        Message: {
            name: "Message",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                audience: {
                    name: "audience",
                    type: "MessageAudience",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("ACCOUNT") }] }] as readonly AttributeApplication[],
                    default: "ACCOUNT" as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "messages", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                severity: {
                    name: "severity",
                    type: "MessageSeverity",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("INFO") }] }] as readonly AttributeApplication[],
                    default: "INFO" as FieldDefault
                },
                title: {
                    name: "title",
                    type: "String"
                },
                body: {
                    name: "body",
                    type: "String"
                },
                callId: {
                    name: "callId",
                    type: "String",
                    unique: true,
                    optional: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[],
                    foreignKeyFor: [
                        "call"
                    ] as readonly string[]
                },
                call: {
                    name: "call",
                    type: "Call",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("callId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "notification", fields: ["callId"], references: ["id"], onDelete: "SetNull" }
                },
                createdById: {
                    name: "createdById",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "createdBy"
                    ] as readonly string[]
                },
                createdBy: {
                    name: "createdBy",
                    type: "User",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("messageAuthor") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("createdById")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "authoredMessages", name: "messageAuthor", fields: ["createdById"], references: ["id"], onDelete: "SetNull" }
                },
                reads: {
                    name: "reads",
                    type: "MessageRead",
                    array: true,
                    relation: { opposite: "message" }
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("createdAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("createdById")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.field("audience"), "==", ExpressionUtils.literal("PLATFORM_ALL")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("audience"), "==", ExpressionUtils.literal("ACCOUNT")), "&&", ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"])), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                callId: { type: "String" }
            }
        },
        MessageRead: {
            name: "MessageRead",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                messageId: {
                    name: "messageId",
                    type: "String",
                    foreignKeyFor: [
                        "message"
                    ] as readonly string[]
                },
                message: {
                    name: "message",
                    type: "Message",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("messageId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "reads", fields: ["messageId"], references: ["id"], onDelete: "Cascade" }
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "messageReads", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                readAt: {
                    name: "readAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@unique", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("messageId"), ExpressionUtils.field("userId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")), "||", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId"))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("create,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                messageId_userId: { messageId: { type: "String" }, userId: { type: "String" } }
            }
        },
        PushSubscription: {
            name: "PushSubscription",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                userId: {
                    name: "userId",
                    type: "String",
                    foreignKeyFor: [
                        "user"
                    ] as readonly string[]
                },
                user: {
                    name: "user",
                    type: "User",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "pushSubscriptions", fields: ["userId"], references: ["id"], onDelete: "Cascade" }
                },
                endpoint: {
                    name: "endpoint",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                p256dh: {
                    name: "p256dh",
                    type: "String",
                    omit: true,
                    attributes: [{ name: "@omit" }] as readonly AttributeApplication[]
                },
                auth: {
                    name: "auth",
                    type: "String",
                    omit: true,
                    attributes: [{ name: "@omit" }] as readonly AttributeApplication[]
                },
                userAgent: {
                    name: "userAgent",
                    type: "String",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("userId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"]), "==", ExpressionUtils.field("userId")) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                endpoint: { type: "String" }
            }
        },
        AuditLog: {
            name: "AuditLog",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "auditLog", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                actorUserId: {
                    name: "actorUserId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "actor"
                    ] as readonly string[]
                },
                actor: {
                    name: "actor",
                    type: "User",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("auditActor") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("actorUserId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "auditEntries", name: "auditActor", fields: ["actorUserId"], references: ["id"], onDelete: "SetNull" }
                },
                action: {
                    name: "action",
                    type: "String"
                },
                targetType: {
                    name: "targetType",
                    type: "String",
                    optional: true
                },
                targetId: {
                    name: "targetId",
                    type: "String",
                    optional: true
                },
                metadata: {
                    name: "metadata",
                    type: "Json",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId"), ExpressionUtils.field("createdAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("actorUserId")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["approved"]), "&&", ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")), "||", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("ADMIN")))))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" }
            }
        },
        Invite: {
            name: "Invite",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                email: {
                    name: "email",
                    type: "String"
                },
                token: {
                    name: "token",
                    type: "String",
                    unique: true,
                    omit: true,
                    attributes: [{ name: "@unique" }, { name: "@omit" }] as readonly AttributeApplication[]
                },
                role: {
                    name: "role",
                    type: "Role",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("USER") }] }] as readonly AttributeApplication[],
                    default: "USER" as FieldDefault
                },
                accountId: {
                    name: "accountId",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "account"
                    ] as readonly string[]
                },
                account: {
                    name: "account",
                    type: "Account",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("Cascade") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "invites", fields: ["accountId"], references: ["id"], onDelete: "Cascade" }
                },
                accountRole: {
                    name: "accountRole",
                    type: "AccountRole",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                invitedById: {
                    name: "invitedById",
                    type: "String",
                    optional: true,
                    foreignKeyFor: [
                        "invitedBy"
                    ] as readonly string[]
                },
                invitedBy: {
                    name: "invitedBy",
                    type: "User",
                    optional: true,
                    attributes: [{ name: "@relation", args: [{ name: "name", value: ExpressionUtils.literal("invitedBy") }, { name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("invitedById")]) }, { name: "references", value: ExpressionUtils.array("String", [ExpressionUtils.field("id")]) }, { name: "onDelete", value: ExpressionUtils.literal("SetNull") }] }] as readonly AttributeApplication[],
                    relation: { opposite: "invitesSent", name: "invitedBy", fields: ["invitedById"], references: ["id"], onDelete: "SetNull" }
                },
                visitedAt: {
                    name: "visitedAt",
                    type: "DateTime",
                    optional: true
                },
                usedAt: {
                    name: "usedAt",
                    type: "DateTime",
                    optional: true
                },
                expiresAt: {
                    name: "expiresAt",
                    type: "DateTime"
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                }
            },
            attributes: [
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("email"), ExpressionUtils.field("usedAt")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("accountId")]) }] },
                { name: "@@index", args: [{ name: "fields", value: ExpressionUtils.array("String", [ExpressionUtils.field("invitedById")]) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("read,delete") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.field("account"), ["members"]), "?", ExpressionUtils.binary(ExpressionUtils.binary(ExpressionUtils.field("userId"), "==", ExpressionUtils.member(ExpressionUtils.call("auth"), ["id"])), "&&", ExpressionUtils.binary(ExpressionUtils.field("role"), "==", ExpressionUtils.literal("OWNER")))) }] },
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                token: { type: "String" }
            }
        },
        EmailDelivery: {
            name: "EmailDelivery",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    id: true,
                    attributes: [{ name: "@id" }, { name: "@default", args: [{ name: "value", value: ExpressionUtils.call("cuid") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("cuid") as FieldDefault
                },
                resendId: {
                    name: "resendId",
                    type: "String",
                    unique: true,
                    attributes: [{ name: "@unique" }] as readonly AttributeApplication[]
                },
                template: {
                    name: "template",
                    type: "String"
                },
                to: {
                    name: "to",
                    type: "String"
                },
                status: {
                    name: "status",
                    type: "String",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.literal("sent") }] }] as readonly AttributeApplication[],
                    default: "sent" as FieldDefault
                },
                idempotencyKey: {
                    name: "idempotencyKey",
                    type: "String",
                    optional: true
                },
                lastEventAt: {
                    name: "lastEventAt",
                    type: "DateTime",
                    optional: true
                },
                createdAt: {
                    name: "createdAt",
                    type: "DateTime",
                    attributes: [{ name: "@default", args: [{ name: "value", value: ExpressionUtils.call("now") }] }] as readonly AttributeApplication[],
                    default: ExpressionUtils.call("now") as FieldDefault
                },
                updatedAt: {
                    name: "updatedAt",
                    type: "DateTime",
                    updatedAt: true,
                    attributes: [{ name: "@updatedAt" }] as readonly AttributeApplication[]
                }
            },
            attributes: [
                { name: "@@allow", args: [{ name: "operation", value: ExpressionUtils.literal("all") }, { name: "condition", value: ExpressionUtils.binary(ExpressionUtils.member(ExpressionUtils.call("auth"), ["role"]), "==", ExpressionUtils.literal("PLATFORM_ADMIN")) }] }
            ] as readonly AttributeApplication[],
            idFields: ["id"],
            uniqueFields: {
                id: { type: "String" },
                resendId: { type: "String" }
            }
        }
    } as const;
    typeDefs = {
        Auth: {
            name: "Auth",
            fields: {
                id: {
                    name: "id",
                    type: "String",
                    attributes: [{ name: "@id" }] as readonly AttributeApplication[]
                },
                role: {
                    name: "role",
                    type: "Role"
                },
                approved: {
                    name: "approved",
                    type: "Boolean"
                }
            },
            attributes: [
                { name: "@@auth" }
            ] as readonly AttributeApplication[]
        },
        SignUpInput: {
            name: "SignUpInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        LoginInput: {
            name: "LoginInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                }
            }
        },
        ChangePasswordInput: {
            name: "ChangePasswordInput",
            fields: {
                currentPassword: {
                    name: "currentPassword",
                    type: "String"
                },
                newPassword: {
                    name: "newPassword",
                    type: "String"
                }
            }
        },
        AdminSetPasswordInput: {
            name: "AdminSetPasswordInput",
            fields: {
                userId: {
                    name: "userId",
                    type: "String"
                },
                newPassword: {
                    name: "newPassword",
                    type: "String"
                }
            }
        },
        AdminInviteUserInput: {
            name: "AdminInviteUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                }
            }
        },
        InviteDelegateInput: {
            name: "InviteDelegateInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                email: {
                    name: "email",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "AccountRole",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        SetMemberRoleInput: {
            name: "SetMemberRoleInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String"
                },
                role: {
                    name: "role",
                    type: "AccountRole"
                }
            }
        },
        RemoveMemberInput: {
            name: "RemoveMemberInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String"
                }
            }
        },
        AdminCreateUserInput: {
            name: "AdminCreateUserInput",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role",
                    optional: true
                },
                approved: {
                    name: "approved",
                    type: "Boolean",
                    optional: true
                }
            }
        },
        UserIdInput: {
            name: "UserIdInput",
            fields: {
                userId: {
                    name: "userId",
                    type: "String"
                }
            }
        },
        AcceptInviteInput: {
            name: "AcceptInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                },
                password: {
                    name: "password",
                    type: "String",
                    optional: true
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                }
            }
        },
        CheckInviteInput: {
            name: "CheckInviteInput",
            fields: {
                token: {
                    name: "token",
                    type: "String"
                }
            }
        },
        CheckInviteResult: {
            name: "CheckInviteResult",
            fields: {
                email: {
                    name: "email",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String",
                    optional: true
                },
                role: {
                    name: "role",
                    type: "Role"
                },
                accountLabel: {
                    name: "accountLabel",
                    type: "String",
                    optional: true
                },
                userExists: {
                    name: "userExists",
                    type: "Boolean"
                }
            }
        },
        InngestRunRow: {
            name: "InngestRunRow",
            fields: {
                runId: {
                    name: "runId",
                    type: "String"
                },
                functionName: {
                    name: "functionName",
                    type: "String",
                    optional: true
                },
                status: {
                    name: "status",
                    type: "String"
                },
                startedAt: {
                    name: "startedAt",
                    type: "String",
                    optional: true
                },
                endedAt: {
                    name: "endedAt",
                    type: "String",
                    optional: true
                },
                output: {
                    name: "output",
                    type: "String",
                    optional: true
                }
            }
        },
        InngestEventRow: {
            name: "InngestEventRow",
            fields: {
                id: {
                    name: "id",
                    type: "String"
                },
                name: {
                    name: "name",
                    type: "String"
                },
                receivedAt: {
                    name: "receivedAt",
                    type: "String",
                    optional: true
                },
                dataJson: {
                    name: "dataJson",
                    type: "String"
                },
                runs: {
                    name: "runs",
                    type: "InngestRunRow",
                    array: true
                }
            }
        },
        InngestActivityResult: {
            name: "InngestActivityResult",
            fields: {
                events: {
                    name: "events",
                    type: "InngestEventRow",
                    array: true
                },
                ok: {
                    name: "ok",
                    type: "Boolean"
                },
                error: {
                    name: "error",
                    type: "String",
                    optional: true
                }
            }
        },
        AssistantChatTurn: {
            name: "AssistantChatTurn",
            fields: {
                role: {
                    name: "role",
                    type: "String"
                },
                content: {
                    name: "content",
                    type: "String"
                }
            }
        },
        AssistantAskInput: {
            name: "AssistantAskInput",
            fields: {
                question: {
                    name: "question",
                    type: "String"
                },
                history: {
                    name: "history",
                    type: "AssistantChatTurn",
                    array: true
                },
                language: {
                    name: "language",
                    type: "String"
                },
                path: {
                    name: "path",
                    type: "String",
                    optional: true
                }
            }
        },
        AccountSummary: {
            name: "AccountSummary",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                label: {
                    name: "label",
                    type: "String",
                    optional: true
                },
                e164: {
                    name: "e164",
                    type: "String",
                    optional: true
                },
                myRole: {
                    name: "myRole",
                    type: "AccountRole"
                },
                unread: {
                    name: "unread",
                    type: "Int"
                },
                needsOnboarding: {
                    name: "needsOnboarding",
                    type: "Boolean"
                },
                setupUnfinished: {
                    name: "setupUnfinished",
                    type: "Boolean"
                }
            }
        },
        AccountSummaryList: {
            name: "AccountSummaryList",
            fields: {
                accounts: {
                    name: "accounts",
                    type: "AccountSummary",
                    array: true
                }
            }
        },
        AccountIdInput: {
            name: "AccountIdInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                }
            }
        },
        AssignPhoneNumberInput: {
            name: "AssignPhoneNumberInput",
            fields: {
                phoneNumberId: {
                    name: "phoneNumberId",
                    type: "String"
                },
                userId: {
                    name: "userId",
                    type: "String"
                }
            }
        },
        PhoneNumberIdInput: {
            name: "PhoneNumberIdInput",
            fields: {
                phoneNumberId: {
                    name: "phoneNumberId",
                    type: "String"
                }
            }
        },
        SkipStepInput: {
            name: "SkipStepInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                step: {
                    name: "step",
                    type: "OnboardingStep"
                }
            }
        },
        AgentFetchInput: {
            name: "AgentFetchInput",
            fields: {
                externalAgentId: {
                    name: "externalAgentId",
                    type: "String"
                }
            }
        },
        AgentDeployFaqInput: {
            name: "AgentDeployFaqInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                }
            }
        },
        AgentSyncResult: {
            name: "AgentSyncResult",
            fields: {
                syncedAt: {
                    name: "syncedAt",
                    type: "DateTime"
                },
                documentId: {
                    name: "documentId",
                    type: "String",
                    optional: true
                }
            }
        },
        AgentSyncInput: {
            name: "AgentSyncInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                }
            }
        },
        WorkspaceUsageInput: {
            name: "WorkspaceUsageInput",
            fields: {
                monthsBack: {
                    name: "monthsBack",
                    type: "Int",
                    optional: true
                }
            }
        },
        AccountUsageInput: {
            name: "AccountUsageInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                monthsBack: {
                    name: "monthsBack",
                    type: "Int",
                    optional: true
                }
            }
        },
        PushSubscribeInput: {
            name: "PushSubscribeInput",
            fields: {
                endpoint: {
                    name: "endpoint",
                    type: "String"
                },
                p256dh: {
                    name: "p256dh",
                    type: "String"
                },
                auth: {
                    name: "auth",
                    type: "String"
                },
                userAgent: {
                    name: "userAgent",
                    type: "String",
                    optional: true
                }
            }
        },
        PushUnsubscribeInput: {
            name: "PushUnsubscribeInput",
            fields: {
                endpoint: {
                    name: "endpoint",
                    type: "String"
                }
            }
        },
        AdminPushInput: {
            name: "AdminPushInput",
            fields: {
                accountId: {
                    name: "accountId",
                    type: "String"
                },
                title: {
                    name: "title",
                    type: "String"
                },
                body: {
                    name: "body",
                    type: "String"
                }
            }
        }
    } as const;
    enums = {
        Role: {
            name: "Role",
            values: {
                PLATFORM_ADMIN: "PLATFORM_ADMIN",
                USER: "USER"
            }
        },
        AccountRole: {
            name: "AccountRole",
            values: {
                OWNER: "OWNER",
                ADMIN: "ADMIN",
                RESPONDER: "RESPONDER",
                VIEWER: "VIEWER"
            }
        },
        UrgencyLevel: {
            name: "UrgencyLevel",
            values: {
                LOW: "LOW",
                NORMAL: "NORMAL",
                HIGH: "HIGH",
                URGENT: "URGENT"
            }
        },
        CallStatus: {
            name: "CallStatus",
            values: {
                IN_PROGRESS: "IN_PROGRESS",
                COMPLETED: "COMPLETED",
                FAILED: "FAILED"
            }
        },
        TagSource: {
            name: "TagSource",
            values: {
                AUTO: "AUTO",
                MANUAL: "MANUAL"
            }
        },
        MessageSeverity: {
            name: "MessageSeverity",
            values: {
                INFO: "INFO",
                IMPORTANT: "IMPORTANT",
                CRITICAL: "CRITICAL"
            }
        },
        MessageAudience: {
            name: "MessageAudience",
            values: {
                ACCOUNT: "ACCOUNT",
                PLATFORM_ALL: "PLATFORM_ALL",
                PLATFORM_ADMIN: "PLATFORM_ADMIN"
            }
        },
        ProvisioningStatus: {
            name: "ProvisioningStatus",
            values: {
                AVAILABLE: "AVAILABLE",
                PROVISIONING: "PROVISIONING",
                ACTIVE: "ACTIVE",
                FAILED: "FAILED",
                RELEASED: "RELEASED"
            }
        },
        OnboardingStep: {
            name: "OnboardingStep",
            values: {
                NUMBER: "NUMBER",
                AGENT_PERSONALIZATION: "AGENT_PERSONALIZATION",
                EMERGENCY_TOPICS: "EMERGENCY_TOPICS",
                FORWARDING_SETUP: "FORWARDING_SETUP",
                TEST_CALL: "TEST_CALL"
            }
        }
    } as const;
    authType = "Auth" as const;
    procedures = {
        signUp: {
            params: {
                input: { name: "input", type: "SignUpInput" }
            },
            returnType: "String",
            mutation: true
        },
        login: {
            params: {
                input: { name: "input", type: "LoginInput" }
            },
            returnType: "String",
            mutation: true
        },
        me: {
            params: {},
            returnType: "User"
        },
        changePassword: {
            params: {
                input: { name: "input", type: "ChangePasswordInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        adminSetPassword: {
            params: {
                input: { name: "input", type: "AdminSetPasswordInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        adminInviteUser: {
            params: {
                input: { name: "input", type: "AdminInviteUserInput" }
            },
            returnType: "Invite",
            mutation: true
        },
        adminCreateUser: {
            params: {
                input: { name: "input", type: "AdminCreateUserInput" }
            },
            returnType: "User",
            mutation: true
        },
        adminDeleteUser: {
            params: {
                input: { name: "input", type: "UserIdInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        acceptInvite: {
            params: {
                input: { name: "input", type: "AcceptInviteInput" }
            },
            returnType: "String",
            mutation: true
        },
        checkInvite: {
            params: {
                input: { name: "input", type: "CheckInviteInput" }
            },
            returnType: "CheckInviteResult",
            mutation: true
        },
        inviteDelegate: {
            params: {
                input: { name: "input", type: "InviteDelegateInput" }
            },
            returnType: "Invite",
            mutation: true
        },
        setMemberRole: {
            params: {
                input: { name: "input", type: "SetMemberRoleInput" }
            },
            returnType: "AccountMember",
            mutation: true
        },
        removeMember: {
            params: {
                input: { name: "input", type: "RemoveMemberInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        claimOwnAccount: {
            params: {},
            returnType: "Account",
            mutation: true
        },
        myAccounts: {
            params: {},
            returnType: "AccountSummaryList"
        },
        provisionNumber: {
            params: {
                input: { name: "input", type: "AccountIdInput" }
            },
            returnType: "PhoneNumber",
            mutation: true
        },
        assignPhoneNumber: {
            params: {
                input: { name: "input", type: "AssignPhoneNumberInput" }
            },
            returnType: "PhoneNumber",
            mutation: true
        },
        releasePhoneNumber: {
            params: {
                input: { name: "input", type: "PhoneNumberIdInput" }
            },
            returnType: "PhoneNumber",
            mutation: true
        },
        skipOnboardingStep: {
            params: {
                input: { name: "input", type: "SkipStepInput" }
            },
            returnType: "OnboardingProgress",
            mutation: true
        },
        completeOnboarding: {
            params: {
                input: { name: "input", type: "AccountIdInput" }
            },
            returnType: "OnboardingProgress",
            mutation: true
        },
        agentDeployFaq: {
            params: {
                input: { name: "input", type: "AgentDeployFaqInput" }
            },
            returnType: "AgentSyncResult",
            mutation: true
        },
        agentFetch: {
            params: {
                input: { name: "input", type: "AgentFetchInput" }
            },
            returnType: "String",
            mutation: true
        },
        agentSync: {
            params: {
                input: { name: "input", type: "AgentSyncInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        workspaceUsage: {
            params: {
                input: { name: "input", type: "WorkspaceUsageInput" }
            },
            returnType: "String"
        },
        accountUsage: {
            params: {
                input: { name: "input", type: "AccountUsageInput" }
            },
            returnType: "String"
        },
        pushPublicKey: {
            params: {},
            returnType: "String"
        },
        pushSubscribe: {
            params: {
                input: { name: "input", type: "PushSubscribeInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        pushUnsubscribe: {
            params: {
                input: { name: "input", type: "PushUnsubscribeInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        pushTest: {
            params: {},
            returnType: "Boolean",
            mutation: true
        },
        adminPushAccount: {
            params: {
                input: { name: "input", type: "AdminPushInput" }
            },
            returnType: "Boolean",
            mutation: true
        },
        inngestActivity: {
            params: {},
            returnType: "InngestActivityResult"
        },
        assistantAsk: {
            params: {
                input: { name: "input", type: "AssistantAskInput" }
            },
            returnType: "String",
            mutation: true
        }
    } as const;
    plugins = {};
}
export const schema = new SchemaType();
